import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../api";

function EmpleadoModal({ empleado, onClose, onSuccess }) {
  const editing = !!empleado?.id;
  const [form, setForm] = useState({
    dni:      empleado?.dni      || "",
    nombre:   empleado?.nombre   || "",
    apellido: empleado?.apellido || "",
    email:    empleado?.email    || "",
    pin:      "",
  });
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);

  function update(field) { return e => setForm(p => ({ ...p, [field]: e.target.value })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (editing) {
        const body = { nombre:form.nombre, apellido:form.apellido, email:form.email };
        if (form.pin) body.pin = form.pin;
        await api.editarEmpleado(empleado.id, body);
      } else {
        if (!form.pin) return setError("El PIN es obligatorio");
        await api.crearEmpleado(form);
      }
      onSuccess();
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:20 }}>
      <div className="card" style={{ maxWidth:460,width:"100%" }}>
        <h3 style={{ color:"var(--navy)",marginBottom:20 }}>
          {editing ? "Editar empleado" : "Nuevo empleado"}
        </h3>
        <form onSubmit={handleSubmit} style={{ display:"flex",flexDirection:"column",gap:14 }}>
          {!editing && (
            <div className="input-group">
              <label>DNI</label>
              <input type="text" inputMode="numeric" value={form.dni} onChange={update("dni")} placeholder="Sin puntos" required />
            </div>
          )}
          <div style={{ display:"grid",gridTemplateColumns:"1fr",gap:12 }}>
            <div className="input-group">
              <label>Nombre</label>
              <input type="text" value={form.nombre} onChange={update("nombre")} required />
            </div>
            <div className="input-group">
              <label>Apellido</label>
              <input type="text" value={form.apellido} onChange={update("apellido")} required />
            </div>
          </div>
          <div className="input-group">
            <label>Email</label>
            <input type="email" value={form.email} onChange={update("email")} required />
          </div>
          <div className="input-group">
            <label>{editing ? "Nuevo PIN (dejá vacío para no cambiar)" : "PIN"}</label>
            <input type="password" inputMode="numeric" value={form.pin} onChange={update("pin")}
              placeholder="Mínimo 4 dígitos" required={!editing} />
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          <div style={{ display:"flex",gap:10,marginTop:4 }}>
            <button type="button" className="btn btn-full" onClick={onClose} disabled={loading}>Cancelar</button>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? "Guardando…" : editing ? "Guardar cambios" : "Crear empleado"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function EmpleadosAdmin() {
  const [empleados, setEmpleados] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [modal, setModal]         = useState(false);
  const [error, setError]         = useState("");
  const [success, setSuccess]     = useState("");
  const [busqueda, setBusqueda]   = useState("");

  async function cargar() {
    setLoading(true);
    try { setEmpleados(await api.getEmpleados()); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }

  useEffect(() => { cargar(); }, []);

  async function toggleActivo(emp) {
    try {
      await api.editarEmpleado(emp.id, { activo: !emp.activo });
      await cargar();
    } catch (e) { setError(e.message); }
  }

  const filtrados = empleados.filter(e => {
    const q = busqueda.toLowerCase();
    return !q || `${e.nombre} ${e.apellido} ${e.dni} ${e.email}`.toLowerCase().includes(q);
  });

  return (
    <Layout>
      {modal !== undefined && modal !== false && (
        <EmpleadoModal
          empleado={modal}
          onClose={() => setModal(false)}
          onSuccess={() => { setModal(false); setSuccess("Empleado guardado."); cargar(); }}
        />
      )}

      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:24,flexWrap:"wrap",gap:12 }}>
        <div>
          <h1 style={{ fontSize:24,fontWeight:700,color:"var(--navy)" }}>Empleados</h1>
          <p style={{ color:"var(--gray)",marginTop:4 }}>{empleados.filter(e=>e.activo).length} activos</p>
        </div>
        <button className="btn btn-primary" onClick={() => setModal({})}>+ Nuevo empleado</button>
      </div>

      {error && <div className="alert alert-error" style={{ marginBottom:16 }}>{error}</div>}
      {success && <div className="alert alert-success" style={{ marginBottom:16 }}>{success}</div>}

      <div style={{ marginBottom:16 }}>
        <input
          type="search"
          placeholder="Buscar por nombre, DNI o email…"
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          style={{ padding:"9px 14px",border:"1.5px solid var(--border)",borderRadius:"var(--radius)",fontFamily:"inherit",fontSize:14,width:"100%",maxWidth:380 }}
        />
      </div>

      {loading ? (
        <div style={{ padding:60,textAlign:"center" }}><div className="spinner" /></div>
      ) : (
        <div className="card" style={{ padding:0,overflow:"hidden" }}>
          <table>
            <thead>
              <tr>
                <th>Apellido y nombre</th>
                <th>DNI</th>
                <th>Email</th>
                <th>Estado</th>
                <th>Último acceso</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map(e => (
                <tr key={e.id} style={{ opacity: e.activo ? 1 : .5 }}>
                  <td style={{ fontWeight:500 }}>{e.apellido}, {e.nombre}</td>
                  <td style={{ fontFamily:"monospace" }}>{e.dni}</td>
                  <td style={{ fontSize:13,color:"var(--gray)" }}>{e.email}</td>
                  <td>
                    <span className={`badge ${e.activo ? "badge-firmado" : "badge-borrador"}`}>
                      {e.activo ? "Activo" : "Inactivo"}
                    </span>
                  </td><td style={{ fontSize:13, color:"var(--gray)" }}>
  {e.ultimo_acceso ? new Date(e.ultimo_acceso).toLocaleString("es-AR") : "Nunca"}</td>
                  <td>
                    <div style={{ display:"flex",gap:8 }}>
                      <button className="btn btn-sm" onClick={() => setModal(e)}>Editar</button>
                      <button className="btn btn-sm" style={{ borderColor:"var(--gray)",color:"var(--gray)" }}
                        onClick={() => toggleActivo(e)}>
                        {e.activo ? "Desactivar" : "Activar"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {filtrados.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign:"center",padding:40,color:"var(--gray)" }}>Sin resultados</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
